import { BookOpenText } from "lucide-react";
import { HistoryItem } from "@/components/history/HistoryItem";

export const HistoryList = ({ items, loading }) => (
  <section className="space-y-4" data-testid="history-list-section">
    {loading ? (
      <div className="flex min-h-56 items-center justify-center rounded-2xl border border-[#E5E1D8] bg-white p-8 text-center font-serif-display text-3xl text-[#1A3626]" data-testid="history-loading-state">
        Gathering reflections…
      </div>
    ) : items.length ? (
      items.map((item, index) => <HistoryItem key={item.id} item={item} index={index} />)
    ) : (
      <div className="flex min-h-72 flex-col items-center justify-center rounded-2xl border border-[#E5E1D8] bg-white p-8 text-center" data-testid="history-empty-state">
        <BookOpenText className="mb-4 text-[#C87961]" size={36} />
        <p className="font-serif-display text-3xl font-semibold text-[#1A3626]" data-testid="history-empty-title">No reflections yet</p>
        <p className="mt-2 max-w-md text-[#4A5D4E]" data-testid="history-empty-copy">Once you save daily, weekly, or monthly reflections, they will gather here.</p>
      </div>
    )}
  </section>
);